import React, { useState, useEffect, useContext } from 'react'
import { Form, Typography, Result } from 'antd'
import { Link, useHistory } from 'react-router-dom';
import { appContext } from "../../AppContext";
//Utill fields
import SubmitButton from './../../Utils/SubmitButton';
import InputField from './../../Utils/InputField';
//Hooks
import { useTranslation } from 'react-i18next'
import { useErrorMessage } from './../../Utils/Hooks/useErrorMessage'
import { useFetch } from './../../Utils/Hooks/useFetch'
import { useFormLayout } from './../../Utils/Hooks/useFormLayout'

const { Title, Text } = Typography; 
const size = "large"

export default function Forgot()
{
    const [appState] = useContext(appContext);
    const { t } = useTranslation(['login', 'utils'])       
    const layout = useFormLayout(size, "vertical"); 
    const history = useHistory();

    const [isLoading, setIsLoading] = useState(true)
    const [errorMessage, setErrorMessage] = useErrorMessage('')
    const [isSendingEmail, setIsSendingEmail] = useState(false);
    const [isMailSend, setIsMailSend] = useState(false);

    const [doFetch, FetchType] = useFetch();

    useEffect(() => {
        setIsLoading(false)
    }, [])

    if(isMailSend)
    {
        setTimeout(() => {
            history.goBack()
          }, 10000);

        return (
            <>
                <Result
                    status="success"
                    title={t("forgotPassword.successTitle")}
                    subTitle={t("forgotPassword.successSubtitle")}
                />
                <Link to={"/"}> {t("forgotPassword.backToLogin")} </Link>
            </>
        )
    }

    return (
        <div>
            <Title level={1} >{t("forgotPassword.title")}</Title>
            <Form
            {...layout}
            name="basic"
            onFinish={onSubmitClick} >
                <InputField 
                    input="username" 
                    size={size} 
                    label={t("login.username")}      
                    isRequired={true} 
                    isRequiredText={t("login.usernameRequired")} 
                    isLoading={isLoading}/>

                <SubmitButton 
                    isLoading={isLoading} 
                    isDoingAction={isSendingEmail} 
                    originalText={t("forgotPassword.submit")} 
                    loadingText={t("forgotPassword.loading")} 
                    size={size}/>

                <Text type="danger">{errorMessage}</Text>
            </Form>
            <Link to={"/"}> {t("forgotPassword.backToLogin")} </Link>
        </div>
    )

    function onSubmitClick(values)
    {
        setIsSendingEmail(true)
        const body = { 
            userName: values.username,
            returnUrl: appState.returnUrl
        };

        doFetch(`/Forgot/request`, FetchType.POST, body)
            .then((response) => onForgotFetchLoaded(response.isSuccess, response.result))
        
        function onForgotFetchLoaded(isSuccess, result) {
            isSuccess ? setIsMailSend(true) : setErrorMessage(result);
            setIsSendingEmail(false)
        }
    }
}